import Api from "../../Api";

export const getBestPrice = async (query) => {
  try {
    let res = await Api.get("/best-price", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const exportBestPrice = async (query) => {
  try {
    let res = await Api.get("/best-price/export", {
      responseType:"arraybuffer"
    });
  
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deleteBestPrice = async (id) => {
  try {
    let res = await Api.delete("/best-price/" + id);
  
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};